import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Demo.module.css';

const Demo: React.FC = () => {
  return (
    <>
      <div style={{ marginBottom: '64px' }}>
        <h1>Demo App</h1>
        <hr />
        <div style={{ marginBottom: '32px' }}>
          <h3>Shared Components</h3>
          <div>
            <Link to="/demo/components/AdHocSearch" className={styles.link}>
              AdHoc Search
            </Link>
          </div>
          <div>
            <Link to="components\Acknowledgement" className={styles.link}>
              Acknowledgement
            </Link>
          </div>
          <div>
            <Link to="components\ProgressBarStripe" className={styles.link}>
              AurBarStripe
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Accordion" className={styles.link}>
              Accordion
            </Link>
          </div>
          <div>
            <Link to="/demo/components/AnimatedCard" className={styles.link}>
              Animated Card
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Banner" className={styles.link}>
              Banner
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Button" className={styles.link}>
              Button
            </Link>
          </div>
          <div>
            <Link to="/demo/components/CardGrid" className={styles.link}>
              Card Grid
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Checkbox" className={styles.link}>
              Checkbox
            </Link>
          </div>
          <div>
            <Link to="/demo/components/DataGrid" className={styles.link}>
              Data Grid
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Dialog" className={styles.link}>
              Dialog
            </Link>
          </div>
          <div>
            <Link to="/demo/components/DatePicker" className={styles.link}>
              Date Range Picker
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Drawer" className={styles.link}>
              Drawer
            </Link>
          </div>
          <div>
            <Link to="/demo/components/GroupAvatar" className={styles.link}>
              Group Avatar
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Icon" className={styles.link}>
              Icon
            </Link>
          </div>
          <div>
            <Link to="/demo/components/IndexingBanner" className={styles.link}>
              Indexing Banner
            </Link>
          </div>
          <div>
            <Link to="/demo/components/IndexingOverviewPage" className={styles.link}>
              Indexing Overview Page
            </Link>
          </div>
          <div>
            <Link to="/demo/components/LoadingButton" className={styles.link}>
              Loading Button
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Chip" className={styles.link}>
              Chip
            </Link>
          </div>
          <div>
            <Link
              to="/demo/components/LoadingIndicator"
              className={styles.link}
            >
              Loading Indicator
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Menu" className={styles.link}>
              Menu
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Pagination" className={styles.link}>
              Pagination
            </Link>
          </div>
          <div>
            <Link to="/demo/components/PaginationPro" className={styles.link}>
              Pagination Pro
            </Link>
          </div>
          <div>
            <Link to="/demo/components/PageHeader" className={styles.link}>
              Page Header
            </Link>
          </div>
          <div>
            <Link to="/demo/components/PieChart" className={styles.link}>
              Pie Chart
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Popup" className={styles.link}>
              Popup
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Pill" className={styles.link}>
              Pill
            </Link>
          </div>
          <div>
            <Link to="/demo/components/ProfilePicture" className={styles.link}>
              Profile Picture
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Progressbar" className={styles.link}>
              Progress Bar
            </Link>
          </div>
          <div>
            <Link to="/demo/components/SearchBox" className={styles.link}>
              SearchBox
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Select" className={styles.link}>
              Select
            </Link>
          </div>
          <div>
            <Link to="/demo/components/SelectDropdown" className={styles.link}>
              Select Dropdown
            </Link>
          </div>
          <div>
            <Link to="/demo/components/StepperTab" className={styles.link}>
              Stepper Tab
            </Link>
          </div>
          <div>
            <Link to="/demo/components/SvgIcon" className={styles.link}>
              Svg Icon
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Switch" className={styles.link}>
              Switch
            </Link>
          </div>
          <div>
            <Link to="/demo/components/TabMenu" className={styles.link}>
              Tab Menu
            </Link>
          </div>
          <div>
            <Link to="/demo/components/TabWithIcons" className={styles.link}>
              Tab With Icons
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Toast" className={styles.link}>
              Toast
            </Link>
          </div>
          <div>
            <Link to="/demo/components/UserProfile" className={styles.link}>
              User Profile
            </Link>
          </div>
          <div>
            <Link
              to="/demo/components/ECAPermissionStatus"
              className={styles.link}
            >
              ECA Permissions Status
            </Link>
          </div>
          <div>
            <Link to="/demo/components/ProgressChart" className={styles.link}>
              Progress Chart
            </Link>
          </div>
          <div>
            <Link to="/demo/components/Alerts" className={styles.link}>
              Alerts
            </Link>
          </div>
          <div>
            <Link
              to="/demo/components/PizzaTrackerProgress"
              className={styles.link}
            >
              Animated Pizza Progress Tracker
            </Link>
          </div>
          <div>
            <Link
              to="/demo/components/PermissionGroupSelect"
              className={styles.link}
            >
              Permission Group Select
            </Link>
          </div>
          <div>
            <Link to="/demo/components/EcaBadges" className={styles.link}>
              ECA Badges
            </Link>
          </div>
          <div>
            <Link to="/demo/components/DraggableList" className={styles.link}>
              DraggableList
            </Link>
          </div>
          <div>
            <Link to="components/DataGridTree" className={styles.link}>
              Data Grid Tree
            </Link>
          </div>
          <div>
            <Link to="/demo/components/EcaSearchLoader" className={styles.link}>
              Eca Search Loader
            </Link>
          </div>
          <div>
            <Link to="/demo/components/TagSelectList" className={styles.link}>
              Tag Select List
            </Link>
          </div>
          <div>
            <Link to="/demo/components/ServiceAgreementSelect" className={styles.link}>
              Service Aggrement Selection Dropdown
            </Link>
          </div>
          <div>
            <Link
              to="/demo/components/VideoController"
              className={styles.link}
            >
              Video Controller
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Demo;
